import type { ElementType, ReactElement } from 'react';
import { fieldIconStyles } from './styles';

interface FieldIconProps {
  icon: ElementType;
}

export const FieldIcon = ({ icon: IconComponent }: FieldIconProps): ReactElement => (
  <IconComponent strokeWidth={1.25} className={fieldIconStyles} />
);
